import { render, staticRenderFns } from "./RirekishoEdit.vue?vue&type=template&id=6b60c3de&scoped=true&"
import script from "./RirekishoEdit.vue?vue&type=script&lang=js&"
export * from "./RirekishoEdit.vue?vue&type=script&lang=js&"
import style0 from "./RirekishoEdit.vue?vue&type=style&index=0&id=6b60c3de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b60c3de",
  null
  
)

export default component.exports